<template>
  <div>
    <el-dialog
      :title="(item.ID ? '编辑' : '新增') + '文章'"
      :visible="visible"
      :close-on-click-modal="false"
      width="75%"
      top="5vh"
      @close="onClose"
      @open="onOpen"
    >
      <el-form ref="itemform" :model="item" :rules="rules" label-width="85px">
        <el-form-item label="文章标题" prop="Title">
          <el-input
            v-model.trim="item.Title"
            placeholder="请输入文章标题"
          ></el-input> </el-form-item
        ><el-form-item label="所属分类" prop="WikicatID">
          <el-select
            v-model="item.WikicatID"
            :clearable="false"
            filterable
            placeholder="请选择所属分类"
            style="width: 100%"
          >
            <el-option
              v-for="c in wikicatList"
              :key="c.ID"
              :label="c.Title"
              :value="c.ID"
              :style="{ marginLeft: 15 * c.space + 'px' }"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文章内容" prop="Content">
          <mavon-editor
            ref="md"
            v-model="item.Content"
            :toolbars="toolbars"
            :box-shadow="false"
            @imgAdd="imgAdd"
            @imgDel="imgDel"
          />
        </el-form-item>
        <el-form-item label="发布日期" prop="PublishedAt">
          <el-date-picker
            v-model="item.PublishedAt"
            style="width: 100%"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否置顶">
          <el-switch v-model="isTop"></el-switch>
        </el-form-item>
        <el-form-item label="文章标签" prop="Tags">
          <el-select
            v-model="item.Tags"
            :multiple-limit="6"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请选择或创建文章标签"
            style="width: 100%"
          >
            <el-option
              v-for="(tag, index) in tagList"
              :key="index"
              :label="tag"
              :value="tag"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频地址">
          <el-input
            :class="{
              'mar-btm':
                item.VideoAddress.length > 1 &&
                index !== item.VideoAddress.length - 1,
            }"
            v-for="(obj, index) in item.VideoAddress"
            v-model="item.VideoAddress[index]"
            :key="index"
            placeholder="请填写视频的网址"
          >
            <i
              v-if="index === item.VideoAddress.length - 1"
              slot="append"
              class="fa fa-plus-circle cur-pointer"
              style="
                font-size: 18px;
                position: relative;
                top: 1px;
                color: #86c042;
              "
              @click="item.VideoAddress.push('')"
            ></i>
            <i
              v-if="item.VideoAddress.length > 1"
              slot="append"
              class="fa fa-minus-circle mar-lft cur-pointer"
              style="
                font-size: 18px;
                position: relative;
                top: 1px;
                color: #ee4a47;
                padding-left: 10px;
              "
              @click="item.VideoAddress.splice(index, 1)"
            ></i>
            <i
              slot="append"
              class="fas fa-fw fa-eye cur-pointer"
              style="
                font-size: 18px;
                position: relative;
                top: 1px;
                padding-left: 10px;
              "
              @click="viewVidio(item.VideoAddress[index])"
            ></i>
          </el-input>
        </el-form-item>
        <el-form-item label="文件上传" prop="file">
          <el-upload
            ref="upload"
            :action="uploadUrl"
            :headers="uploadHeader"
            :file-list="fileList"
            :auto-upload="false"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-remove="handleRemove"
            :on-preview="handlePreview"
          >
            <el-button size="mini" type="primary">选择文件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="onClose">
          <i class="fas fa-fw fa-times" aria-hidden="true" /> 取 消
        </el-button>
        <el-button :disabled="submitting" type="primary" @click="onSubmit">
          <i class="far fa-fw fa-save" aria-hidden="true" /> 确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
    tagList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const valideTags = (rule, value, callback) => {
      if (this.item.tags && this.item.tags.length - 1 >= 0) {
        if (this.item.tags[this.item.tags.length - 1].length > 12) {
          this.item.tags.pop();
          callback(new Error("标签不能超过12个字"));
        }
      }
      callback();
    };
    return {
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
      uploadUrl: "",
      fileList: [],
      removeList: [],
      wikicatList: [],
      item: {},
      isTop: false, //是否置顶
      rules: {
        Title: [
          {
            required: true,
            message: "文章标题不能为空",
            trigger: "change, blur",
          },
          {
            max: 200,
            message: "文章标题不能超过200个字符",
            trigger: "change, blur",
          },
        ],
        WikicatID: [
          {
            required: true,
            message: "文章分类不能为空",
            trigger: "change, blur",
          },
        ],
        Content: [
          {
            required: true,
            message: "文章内容不能为空",
            trigger: "change, blur",
          },
          {
            max: 64000,
            message: "文章内容不能超过64000个字符",
            trigger: "change, blur",
          },
        ],
        PublishedAt: [
          {
            required: true,
            message: "发布日期不能为空",
            trigger: "change, blur",
          },
        ],
        Tags: [{ validator: valideTags, trigger: "change, blur" }],
      },
      requestRegObj: {
        reg: /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/, // eslint-disable-line
        msg: "URL格式不正确",
      },
      attnum: 0,
      atttimes: 0,
      submitting: false,
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        // code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        // readmodel: true, // 沉浸式阅读
        htmlcode: true, // 展示html源码
        // /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        // /* 1.4.2 */
        // navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true, // 预览
      },
      spanceNum: 0,
      treePager: {
        total: 0,
        page: 1,
        size: -1,
      },
    };
  },
  methods: {
    onOpen() {
      this.item = _.clone(this.value);
      this.item.WikicatID =
        this.item.WikicatID === 0 ? "" : this.item.WikicatID;
      this.getWikicatTree();
      this.uploadUrl =
        this.item.BusinessGroup === 0
          ? `api/dci/wiki/upload`
          : `api/ipc/wiki/upload`;
      if (this.item.Attachments) {
        this.value.Attachments.forEach((ele) => {
          const file = {};
          // file.id = ele.ID;
          file.name = ele.Name;
          file.url = ele.Url;
          this.fileList.push(file);
        });
      } else {
        this.item.Attachments = [];
      }

      if (this.item.StickedAt) {
        this.isTop = true;
      }
    },

    //获取文章分类树
    getWikicatTree() {
      this.wikicatList = [];
      this.$axios
        .get(
          this.item.BusinessGroup === 0
            ? "dci/wikicat/publish"
            : "ipc/wikicat/publish",
          {
            params: {
              where: {
                BusinessGroup: this.item.BusinessGroup,
              },
              return_tree: 1,
              with: ["Parent"],
              ...this.treePager,
              order: ["-sort", "title"],
            },
          }
        )
        .then((response) => {
          response.data.forEach((ele) => {
            this.spanceNum = 0;
            this.getChild(ele);
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    // 递归获取,因为不知道children有多少层
    getChild(item) {
      const data = item;
      this.spanceNum = 0;
      this.getSpanceNum(data);
      data.space = this.spanceNum;
      if (!data.Children) {
        data.Children = [];
      }
      this.wikicatList.push(data);
      data.Children.forEach((childItem) => {
        this.getChild(childItem);
      });
    },
    // 计算这个之前有多少个父结点，就要显示多少个空格
    getSpanceNum(item) {
      if (item.ParentID !== 0) {
        this.spanceNum++;
        this.getSpanceNum(
          this.wikicatList[
            _.findIndex(this.wikicatList, (c) => c.ID === item.ParentID)
          ]
        );
      }
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      this.$refs.upload.clearFiles();
      this.fileList = [];
      this.removeList = [];
    },
    // 对网址的验证
    targetValidator() {
      const errorMsg = this.requestRegObj.msg;
      const array = [];
      this.item.VideoAddress.forEach((obj, index) => {
        if (obj !== "" && !this.requestRegObj.reg.test(obj)) {
          array.push(index);
        }
      });
      if (array.length > 0) {
        this.$message({
          type: "warning",
          message: `${`视频地址中第${array
            .map((num) => num + 1)
            .join(" ")}个${errorMsg}`}`,
        });
        return false;
      }
      return true;
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        // 验证视频地址
        if (!this.targetValidator()) {
          return;
        }
        this.submitting = true;

        this.attnum = 0; //有没有新上传附件
        this.$refs.upload.uploadFiles.forEach((item) => {
          if (item.status === "ready") {
            this.attnum += 1;
          }
        });
        if (this.attnum > 0) {
          this.atttimes = 0;
          this.$refs.upload.uploadFiles.map((item) => item.status === "ready");
          this.$refs.upload.submit();
        } else {
          this.lastSubmit();
        }
      });
    },
    imgAdd(pos, file) {
      const formData = new FormData();
      // formData.append("hint", "attachment");
      formData.append("file", file);
      this.$axios
        .post(
          this.item.BusinessGroup === 0
            ? "dci/wiki/imgUpload"
            : "ipc/wiki/imgUpload",
          formData
        )
        .then((response) => {
          this.$refs.md.$img2Url(pos, response.data.Url);
        });
    },
    imgDel(pos) {
      this.item.Content = this.item.Content.replace(
        `![img.jpg](${pos[0]})`,
        ""
      );
    },
    handleSuccess(response) {
      this.item.Attachments.push(response);
      this.atttimes += 1; //第几次调用改方法（每个文件都会调用一次，最后一次再触发保存）

      if (this.atttimes === this.attnum) {
        this.lastSubmit();
      }
    },
    handleRemove(file) {
      if (file.status === "success") {
        this.removeList.push(file.url);
      }
    },
    handlePreview(file) {
      const a = document.createElement("a");
      a.setAttribute("download", file.name);
      a.setAttribute("href", file.url);
      a.click();
    },
    lastSubmit() {
      if (this.removeList.length !== 0) {
        this.removeList.forEach((ele) => {
          this.item.Attachments.splice(
            this.item.Attachments.findIndex((item) => item.Url === ele),
            1
          );
        });
        this.$axios.delete("wiki/dispose", { data: { file: this.removeList } });
      }
      if (this.isTop) {
        this.item.StickedAt = new Date();
      }else{
        this.item.StickedAt = null;
      }
      this.$axios
        .request({
          url: this.item.ID
            ? this.item.BusinessGroup === 0
              ? `dci/wiki/publish/${this.item.ID}`
              : `ipc/wiki/publish/${this.item.ID}`
            : this.item.BusinessGroup === 0
            ? "dci/wiki/publish"
            : "ipc/wiki/publish",
          method: this.item.ID ? "put" : "post",
          data: this.item,
        })
        .then(() => {
          this.$message.success(this.item.ID ? "成功编辑文章" : "成功新增文章");
          this.$emit("form:saved", true);
          this.$emit("form:done", true);
          this.onClose();
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },
    viewVidio(url) {
      if (!this.requestRegObj.reg.test(url)) {
        this.$message({
          type: "warning",
          message: `URL格式不正确`,
        });
        return;
      }

      window.open(url, "_blank");
    },
  },
};
</script>
